// Localizes the order-type labels shown across the POS, receipt, KDS, and CFD.
// The stored value is always 'dine-in' / 'takeout' - only the DISPLAY label changes.
// Commonwealth markets say "Takeaway" instead of the US/PH "Takeout".

const TAKEAWAY_COUNTRIES = new Set(['GB', 'AU', 'NZ', 'IE']);

// Country comes from the explicit arg when available, else the value stashed in
// localStorage at login (so popup windows can localize too).
const _country = (country) =>
  (country ?? (typeof localStorage !== 'undefined' ? localStorage.getItem('pointbunny_business_country') : '') ?? '').toUpperCase();

// The takeout label for a country: "Takeaway" for GB/AU/NZ/IE, otherwise "Takeout".
export const takeoutLabel = (country) =>
  TAKEAWAY_COUNTRIES.has(_country(country)) ? 'Takeaway' : 'Takeout';

// Full label for an order-type value. `upper` returns it upper-cased (for the receipt).
export const orderTypeLabel = (orderType, country, { upper = false } = {}) => {
  const label = orderType === 'takeout' ? takeoutLabel(country) : 'Dine In';
  return upper ? label.toUpperCase() : label;
};
